// src/data/buildingsEnergyVectors.js
const FOOD = {
  net_zero_futures_dvl_shift_high_0909: {
    2025: { electricity: 13,    hydrogen: 0,    fossil: 28.66, biofuels: 9.27, other: 0 },
    2030: { electricity: 12.23, hydrogen: 0,    fossil: 28.81, biofuels: 8.97, other: 0 },
    2035: { electricity: 17.7,  hydrogen: 0,    fossil: 20.2,  biofuels: 10.06, other: 0 },
    2040: { electricity: 12.22, hydrogen: 0,    fossil: 24.64, biofuels: 9.69, other: 0 },
    2045: { electricity: 22.33, hydrogen: 0.13, fossil: 9.95,  biofuels: 13.82, other: 0 },
    2050: { electricity: 32.02, hydrogen: 4.57, fossil: 0,     biofuels: 8.85,  other: 0 },
  },

  net_zero_futures_dvl_shift_low_0909: {
    2025: { electricity: 13,    hydrogen: 0,    fossil: 28.66, biofuels: 9.27, other: 0 },
    2030: { electricity: 12.24, hydrogen: 0,    fossil: 28.84, biofuels: 8.94, other: 0 },
    2035: { electricity: 19.63, hydrogen: 0,    fossil: 18.31, biofuels: 8.24, other: 0 },
    2040: { electricity: 11.26, hydrogen: 0,    fossil: 26.18, biofuels: 9.01, other: 0 },
    2045: { electricity: 22.25, hydrogen: 0.22, fossil: 11.74, biofuels: 11.89, other: 0 },
    2050: { electricity: 32.06, hydrogen: 3.44, fossil: 0.47,  biofuels: 9.92,  other: 0 },
  },

  net_zero_futures_dvl_steer_high_0909: {
    2025: { electricity: 13,    hydrogen: 0,    fossil: 28.66, biofuels: 9.27, other: 0 },
    2030: { electricity: 22.62, hydrogen: 0,    fossil: 18.14, biofuels: 9.34, other: 0 },
    2035: { electricity: 32.6,  hydrogen: 0,    fossil: 4.49,  biofuels: 12.05, other: 0 },
    2040: { electricity: 30.47, hydrogen: 4.52, fossil: 8.19,  biofuels: 6.62,  other: 0 },
    2045: { electricity: 32.85, hydrogen: 6.96, fossil: 2.98,  biofuels: 7.86,  other: 0 },
    2050: { electricity: 35.01, hydrogen: 11.79,fossil: 0,     biofuels: 5.38,  other: 0 },
  },

  net_zero_futures_dvl_steer_low_0909: {
    2025: { electricity: 13,    hydrogen: 0,    fossil: 28.66, biofuels: 9.27, other: 0 },
    2030: { electricity: 22.75, hydrogen: 0,    fossil: 17.52, biofuels: 9.87, other: 0 },
    2035: { electricity: 32.64, hydrogen: 0,    fossil: 3.91,  biofuels: 12.64, other: 0 },
    2040: { electricity: 32.73, hydrogen: 4.41, fossil: 5.57,  biofuels: 6.74,  other: 0 },
    2045: { electricity: 32.93, hydrogen: 7.35, fossil: 1.92,  biofuels: 8.29,  other: 0 },
    2050: { electricity: 35.06, hydrogen: 11.86,fossil: 0,     biofuels: 5.4,   other: 0 },
  },

  net_zero_futures_dvl_transform_high_0909: {
    2025: { electricity: 13,    hydrogen: 0,    fossil: 28.66, biofuels: 9.27, other: 0 },
    2030: { electricity: 11.97, hydrogen: 0,    fossil: 27.21, biofuels: 10.0,  other: 0 },
    2035: { electricity: 10.85, hydrogen: 0.19, fossil: 23.08, biofuels: 9.25,  other: 0 },
    2040: { electricity: 10.74, hydrogen: 0.05, fossil: 18.94, biofuels: 11.82, other: 0 },
    2045: { electricity: 18.2,  hydrogen: 0.99, fossil: 5.82,  biofuels: 16.8,  other: 0 },
    2050: { electricity: 20.65, hydrogen: 2.4,  fossil: 0,     biofuels: 19.7,  other: 0 },
  },

  net_zero_futures_dvl_transform_low_0909: {
    2025: { electricity: 13,    hydrogen: 0,    fossil: 28.66, biofuels: 9.27, other: 0 },
    2030: { electricity: 11.98, hydrogen: 0,    fossil: 27.34, biofuels: 9.87,  other: 0 },
    2035: { electricity: 10.86, hydrogen: 0.2,  fossil: 23.3,  biofuels: 10.01, other: 0 },
    2040: { electricity: 10.67, hydrogen: 0.05, fossil: 19.36, biofuels: 11.11, other: 0 },
    2045: { electricity: 18.17, hydrogen: 1,    fossil: 6.73,  biofuels: 15.56, other: 0 },
    2050: { electricity: 20.71, hydrogen: 3.27, fossil: 0,     biofuels: 18.33, other: 0 },
  },

  net_zero_futures_dvl_shift_high_transstshiftec_2001: {
    2025: { electricity: 13,    hydrogen: 0,    fossil: 28.66, biofuels: 9.27, other: 0 },
    2030: { electricity: 12.23, hydrogen: 0,    fossil: 28.89, biofuels: 8.88,  other: 0 },
    2035: { electricity: 18.06, hydrogen: 0.6,  fossil: 20.02,  biofuels: 9.38, other: 0 },
    2040: { electricity: 11.33, hydrogen: 0.0, fossil: 26.02, biofuels: 9.31, other: 0 },
    2045: { electricity: 22.11, hydrogen: 0.13,    fossil: 10.53,  biofuels: 13.47, other: 0 },
    2050: { electricity: 32.01, hydrogen: 4.19, fossil: 0,     biofuels: 9.32, other: 0 },
  },
};




export default FOOD;
